<template>
  <a-select style="width: 100%" v-model="data" :disabled="disabled" @change="change">
    <a-select-option :value="null">
      {{ $t('不指定渠道') }}
    </a-select-option>
    <a-select-option v-for="item in list" :key="item.platformCode" :value="item.platformCode">
      {{ item.platformName }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
export default {
  name: 'SelectPlatform',
  props: {
    value: {},
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      data: undefined,
      list: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    change(data) {
      this.$emit('update:value', data)
    },
    async getList() {
      let res = await http.post(api.queryPlatformList, {})
      this.list = res.result
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.data = val
      },
    },
  },
}
</script>
